import { useState } from 'react';

const PHOTOS = [
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/5d8deec432fc657d72d157df5507ee4d.jpeg',
    alt: 'Кованый козырёк с двускатной крышей над входом в частный дом',
    caption: 'Кованый козырёк с двускатной крышей',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/67c82cf4aa56c2dc68ed0537c0ae750d.jpeg',
    alt: 'Козырёк с кованым орнаментом над дверью с решёткой',
    caption: 'Козырёк с кованым орнаментом',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/21bb913f27bcf32a9c654938d853e6d2.jpeg',
    alt: 'Плоский козырёк на стойках над входом со ступенями',
    caption: 'Плоский козырёк над входом',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/b58c9adb6a20bab0cde5f5617d302c65.jpeg',
    alt: 'Двускатный козырёк из металла во время монтажа',
    caption: 'Монтаж двускатного козырька',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/ea74abfa8b5fbfc5ddd95586984e2769.jpeg',
    alt: 'Козырёк с кованым декором над крыльцом дома',
    caption: 'Козырёк с кованым декором над крыльцом',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/63eff8ba5061cbf7a43c04a46518e4de.jpeg',
    alt: 'Вид снизу на металлоконструкцию двускатного козырька',
    caption: 'Двускатный козырёк — вид изнутри',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/b02eda8a82d557d7a1ab15c8f030afe9.jpeg',
    alt: 'Кованый козырёк с ажурным фронтоном над входом в деревянный дом',
    caption: 'Кованый козырёк с ажурным фронтоном',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/943906f71ead3cc4de0b5390a9bfc8eb.jpeg',
    alt: 'Козырёк на стойках с кованым декором у кирпичного дома',
    caption: 'Козырёк на стойках с кованым декором',
  },
  {
    src: 'https://static.readdy.ai/image/401a812800a3c57fa50042dc76ab6cbb/705f83677b8163686e0794c76c85cbc2.jpeg',
    alt: 'Большой козырёк над террасой двухэтажного дома с сайдингом',
    caption: 'Козырёк над террасой частного дома',
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox((p) => (p === null ? null : p === 0 ? PHOTOS.length - 1 : p - 1));
  const next = () => setLightbox((p) => (p === null ? null : p === PHOTOS.length - 1 ? 0 : p + 1));

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Наши работы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Реальные козырьки, изготовленные и&nbsp;смонтированные нашей командой
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {PHOTOS.map((photo, idx) => (
            <div
              key={photo.src}
              className="relative overflow-hidden rounded-lg cursor-pointer group"
              style={{ aspectRatio: '4/3' }}
              onClick={() => setLightbox(idx)}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <p className="text-background-50 text-xs font-medium">{photo.caption}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA under gallery */}
        <div className="text-center mt-10">
          <a
            href="https://wa.me/79174131562?text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A5%D0%BE%D1%87%D1%83%20%D1%82%D0%B0%D0%BA%D0%BE%D0%B9%20%D0%B6%D0%B5%20%D0%BA%D0%BE%D0%B7%D1%8B%D1%80%D1%91%D0%BA%2C%20%D0%BA%D0%B0%D0%BA%20%D0%BD%D0%B0%20%D1%84%D0%BE%D1%82%D0%BE."
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 hover:scale-[1.03] cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-image-line text-base"></i>
            </span>
            Хочу такой же — обсудить проект
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 backdrop-blur-sm"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={(e) => { e.stopPropagation(); prev(); }}
            className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          <div
            className="relative max-w-4xl w-full mx-4 md:mx-16"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={PHOTOS[lightbox].src}
              alt={PHOTOS[lightbox].alt}
              className="w-full max-h-[80vh] object-contain rounded-lg"
            />
            <p className="text-background-50/80 text-sm text-center mt-3">{PHOTOS[lightbox].caption}</p>
            <span className="absolute top-3 right-3 text-background-50/60 text-xs">
              {lightbox + 1} / {PHOTOS.length}
            </span>
          </div>

          <button
            onClick={(e) => { e.stopPropagation(); next(); }}
            className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>

          <button
            onClick={() => setLightbox(null)}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-background-50/10 hover:bg-background-50/25 text-background-50 rounded-full transition-all duration-300 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
      )}
    </section>
  );
}